import React, { useState, useCallback, useEffect } from "react";
import history from "../Service/history";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import DefMembershipActions from "../Redux/actions/defMembership-actions";
import PlanGroupActions from "../Redux/transition/plan-group/plan-group.reducer";
import BusinessActions from "../Redux/actions/business-actions"
import DocumentActions from '../Redux/transition/document-upload/document-upload.reducer';
import PaymentActions from "../Redux/transition/payswitch/payswitch.reducer"
import { ActionButtons } from "./ActionButtons";
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import Loading from "./Loading";
import { componentRoutes } from "../Route/ComponentRoutes";
import { useNavigate, useLocation } from 'react-router-dom';
import OnboardingNotification from "../Components/OnboardingNotification";
import SigningPendingNotice from "../Components/SigningPendingNotice";
import GoLiveOutstandingDialog from "../Components/GoLiveOutstandingDialog";
import { hasCurrentProviderCredentials, isLiveCollectionReady } from "../utils/pspOnboarding";

const Breadcrumbs = (props) => {
	const { t } = useTranslation("common");
	const location = useLocation();
	const navigate = useNavigate();
	const pathnames = location.pathname.split("/").filter((x) => x);

	const findPath = () => {
		const exactMatch = componentRoutes.find((element) => element.path === location.pathname);
		if (exactMatch) {
			return exactMatch;
		}

		return componentRoutes.find(({ path }) => {
			if (!path.includes(":")) {
				return false;
			}
			const pattern = `^${path.replace(/:[^/]+/g, "[^/]+")}$`;
			return new RegExp(pattern).test(location.pathname);
		});
	}

	const newPath = findPath()?.breadcrumb
	const updatedPath = t(newPath)
	const resultArray = updatedPath?.split("/").map((segment) => segment.trim()).filter(Boolean);
	const isEnrichmentDetail = pathnames[0] === "crm"
		&& pathnames[1] === "enrichment-requests"
		&& pathnames.length === 3;
	const [customerId, setCustomerId] = useState("")
	const [planId, setPlanId] = useState("")
	const [productId, setProductId] = useState("");
	const [openNotification, setOpenNotification] = useState(false);
	const [subscriberObject, setSubscriberObject] = useState({})

	const defMembership = useSelector((state) => state.defMembership.defMembership)
	const business = useSelector((state) => state.businesses.business)
	const planGroupsGraphed = useSelector((state) => state.planGroups.planGroupsGraphed)
	const fetchingVerifStatus = useSelector((state) => state.documents.fetchingVerifStatus);
	const verificationStatus = useSelector((state) => state.documents.verifStatus);
	const signingPending = useSelector((state) => state.documents.signingPending);
	const fetchingMerchantAgreements = useSelector((state) => state.documents.fetchingMerchantAgreements);
	const paymentCredentials = useSelector((state) => state.payswitch.paymentCredentials);
	const credentials = useSelector((state) => state.payswitch.credentials);
	const businessCustomerRecord = useSelector((state) => state.businessCustomers.businessCustomerRecord)
	const plan = useSelector((state) => state.plans.plan)
	const fetchingPaymentCredentials = useSelector((state) => state.payswitch.fetchingCredentials);
	const subscriber = useSelector((state) => state.subscribers.subscriber)


	const dispatch = useDispatch()
	const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch])
	const getActivePlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedActiveRequest(businessId)) }, [dispatch])
	const getAllPlanGroupsGraphed = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedAllRequest(businessId)) }, [dispatch])
	const getBusiness = useCallback((businessId) => { dispatch(BusinessActions.businessRequest(businessId)) }, [dispatch])
	const getBusinessVerificationStatus = useCallback((businessId) => dispatch(DocumentActions.businessVerificationStatusRequest(businessId)), [dispatch]);
	const getMerchantAgreements = useCallback((businessId, provider) => dispatch(DocumentActions.merchantAgreementsRequest(businessId, provider)), [dispatch]);
	const getPaymentCredentials = useCallback((businessId) => { dispatch(PaymentActions.paymentCredentialRequest(businessId)) }, [dispatch]);
	const getCredentials = useCallback((businessId, provider) => { dispatch(PaymentActions.paySwitchCredentialRequest(businessId, provider)) }, [dispatch]);

	//Fetch breadcrumbs from session storage
	const getAppBreadcrumb = () => {
		let prevCrumbs = sessionStorage.getItem('crumbs');
		if (!prevCrumbs) {
			return prevCrumbs = [];
		}
		return prevCrumbs?.split(',');
	};

	function simulateSet(array) {
		const result = [];
		// Loop through the array using array.map
		array.forEach((value) => {
			// Check if the value is already in the result array
			const index = result.indexOf(value);
			if (index !== -1) {
				// If yes, remove the value from its previous index
				result.splice(index, 1);
			}
			// Push the value to the end of the result array
			result.push(value);
		});
		return result.slice(-1);
	}

	const updateBreadcrumb = (crumb) => {
		let savedCrumbs = crumb;
		if (crumb.length > 8) {
			savedCrumbs = crumb.slice((crumb.length - 8))
		}
		const finalCrumbs = simulateSet(savedCrumbs).join();
		sessionStorage.setItem('crumbs', finalCrumbs)
	};

	const [visible, setVisible] = useState(false)
	const [visiblePlan, setVisiblePlan] = useState(false)
	const [state, setState] = useState({
		visible: false,
		visiblePlan: false,
		hide: true,
		hidePlan: true,
		notOwnerVisible: false,
		notOwnerPaymentVisible: false,
		paymentVisible: false,
		goLiveOutstandingVisible: false,
	})

	const paymentSaved = hasCurrentProviderCredentials({
		credentials,
		paymentCredentials,
		provider: business?.pmtProvider,
	});
	const liveReady = isLiveCollectionReady({
		business,
		credentials,
		paymentCredentials,
		signingPending,
	});

	useEffect(() => {
		if (!defMembership) {
			getMembership()
		}
		if (defMembership) {
			getBusiness(defMembership.business.id)
			getBusinessVerificationStatus(defMembership.business.id);
			getMerchantAgreements(defMembership.business.id, business?.pmtProvider || defMembership.business.pmtProvider);
			getActivePlanGroups(defMembership.business.id)
			getAllPlanGroupsGraphed(defMembership.business.id)
			getPaymentCredentials(defMembership.business.id)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defMembership])

	useEffect(() => {

		history.listen(location => {
			if (location.pathname === '/error' || location.pathname === '/denied' || location.pathname === '/not-found') {
				return updateBreadcrumb([]);
			}
			const newCrumb = [...getAppBreadcrumb(), location.pathname];
			updateBreadcrumb(newCrumb);
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location])

	useEffect(() => {
		if (!business && defMembership) {
			getBusiness(defMembership.business.id)
		}
		if (!planGroupsGraphed && defMembership) {
			getActivePlanGroups(defMembership.business.id)
		}
		if (defMembership) {
			getBusinessVerificationStatus(defMembership.business.id)
			getMerchantAgreements(defMembership.business.id, business?.pmtProvider || defMembership.business.pmtProvider)
			if (business?.pmtProvider) {
				getCredentials(defMembership.business.id, business.pmtProvider)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [business, planGroupsGraphed, defMembership, verificationStatus])

	useEffect(() => {
		let loading = fetchingVerifStatus;
		setState(state => { return { ...state, fetchingVerifRecord: loading } });

		if (verificationStatus) {
			setState(state => { return { ...state, verifStatus: verificationStatus } })
		}
		if (businessCustomerRecord) {
			setCustomerId(businessCustomerRecord.id)
		}
		if (subscriber) {
			setSubscriberObject(subscriber.businessCustomer)
		}
		if (plan) {
			setPlanId(plan.id)
			setProductId(plan.groupId)
		}
	}, [fetchingVerifStatus, verificationStatus, businessCustomerRecord, plan, customerId, subscriber])

	//Toggle not Owner dialogue visibility
	const toggleGoLiveOutstandingDialogue = () => {
		setState((state) => { return { ...state, goLiveOutstandingVisible: !state.goLiveOutstandingVisible } })
	}
	const openGoLiveOutstandingDialog = () => {
		toggleGoLiveOutstandingDialogue();
	}

	//Toggle not Owner dialogue visibility
	const toggleNotOwnerDialogue = () => {
		setState((state) => { return { ...state, notOwnerVisible: !state.notOwnerVisible } })
	}
	//Toggle not Owner payment credential dialogue visibility
	const toggleNotOwnerPaymentDialogue = () => {
		setState((state) => { return { ...state, notOwnerPaymentVisible: !state.notOwnerPaymentVisible } })
	}
	//Toggle not Owner payment credential dialogue visibility
	const togglePaymentDialogue = () => {
		setState((state) => { return { ...state, paymentVisible: !state.paymentVisible } })
	}
	//Toggle not Saved dialogue visibility
	const toggleNotSavedDialogue = () => {
		setState((state) => { return { ...state, notSavedVisible: !state.notSavedVisible } })
	}

	const toggleSetOpenDialog = () => {
		setOpenNotification(!openNotification);
	};

	//Dialog Footer for verif alert**
	const renderVerifFooter = (component, label = t("common.ok")) => {
		const checkPass = component === "not_owner";
		return (
			<div>
				<div>
					<Button label={label} style={{ backgroundColor: "#d0021b" }} icon={checkPass && "pi pi-check"} autoFocus
						onClick={() => { toggleNotOwnerDialogue(); }}
					/>
				</div>
			</div>
		);
	}
	const renderPaymentFooter = (component) => {
		return (
			<div>
				<Button label={t("common.ok")} style={{ backgroundColor: "#d0021b" }} icon="pi pi-check" autoFocus
					onClick={() => toggleNotOwnerPaymentDialogue()}
				/>
			</div>
		);
	}
	const notSavedFooter = () => {
		return (
			<div>
				<Button label={t("common.ok")} icon="pi pi-check" autoFocus
					onClick={toggleNotSavedDialogue}
				/>
			</div>
		);
	}

	const toogleInviteSubscriber = () => {
		if (fetchingVerifStatus || fetchingMerchantAgreements) {
			return <div style={{ height: "100vh" }}><Loading /></div>
		}
		else {
			if (liveReady) {
				setVisible(true)

			}
			else if (signingPending && business.verified && paymentSaved) {
				return openGoLiveOutstandingDialog();
			}
			else if (business.verified && !paymentSaved) {
				return openGoLiveOutstandingDialog();
			}
			else if (!business.verified) {
				if (verificationStatus && !fetchingVerifStatus) {
					return openGoLiveOutstandingDialog();
				}
				if (!verificationStatus && !fetchingVerifStatus) {
					switch (defMembership.role) {
						case "OWNER":
							return <OnboardingNotification visible={true} onHide={toggleSetOpenDialog} />
						default:
							toggleNotOwnerDialogue();
					}
				}
			}
		}
	}
	const tooglePlan = () => {
		setVisiblePlan(true)
	}
	const onHide = () => {
		setVisible(false)
	}
	const onHidePlan = () => {
		setVisiblePlan(false)
	}


	const toogleShareBusiness = () => {

		if (fetchingVerifStatus || fetchingPaymentCredentials || fetchingMerchantAgreements) {
			return <Loading />;
		}
		else {
			if (liveReady) {
				return;
			}
			if (!business.verified && !verificationStatus && !business?.customPmtProvider) {
				if (!state.fetchingVerifRecord) {
					switch (defMembership.role) {
						case "OWNER":
							setOpenNotification(true)
							break;
						default:
							toggleNotOwnerDialogue();
					}
				}
			}
			else {
				return openGoLiveOutstandingDialog();
			}
		}
	};

	const handleRedirect = () => {
		navigate('/settings');
	};
	
	return (
		<>
			<OnboardingNotification visible={openNotification} onHide={toggleSetOpenDialog} />
			<GoLiveOutstandingDialog
				visible={state.goLiveOutstandingVisible}
				onHide={toggleGoLiveOutstandingDialogue}
			/>
			<Dialog
				header={t("idoc.not_owner_header")} style={{ width: "360px" }} visible={state.notOwnerVisible}
				onHide={toggleNotOwnerDialogue} footer={renderVerifFooter('not_owner')}
			>
				<p className="dialog_text">{t("idoc.not_owner_text")}</p>
				<SigningPendingNotice business={business} />
			</Dialog>
			<Dialog
				header={t("idoc.not_owner_header")} style={{ width: "360px" }} visible={state.notOwnerPaymentVisible}
				onHide={toggleNotOwnerPaymentDialogue} footer={renderPaymentFooter}
			>
				<p className="dialog_text">{t("idoc.not_owner_payment_text1")} <span className="not_owner_bold_text">{t("idoc.not_admin_owner_text")}</span> {t("idoc.not_owner_payment_text2")} <span className="not_owner_bold_text">{t("idoc.not_owner_admin_text")}</span> {t("idoc.not_owner_payment_text3")} </p>
				<SigningPendingNotice business={business} />
			</Dialog>
			<Dialog
				header={t("idoc.payment_header")} style={{ width: "360px" }} visible={state.paymentVisible}
				onHide={togglePaymentDialogue} footer={renderVerifFooter('not_owner')}
			>
				<p className="dialog_text">{t("payment_text")} <span onClick={handleRedirect}>{t("add_payment_text")}</span></p>
				<SigningPendingNotice business={business} />
			</Dialog>
			<Dialog
				header={t("idoc.not_owner_header")} visible={state.notSavedVisible}
				onHide={toggleNotSavedDialogue} style={{ width: "360px" }} footer={notSavedFooter}
			>
				<p className="dialog_text">{t("idoc.not_saved_viewer")}</p>
				<SigningPendingNotice business={business} />
			</Dialog>

			<div className='route-bar route-bar-div'>
				<div className='route-bar-breadcrumb'>
					{/* Link back to any previous steps of the breadcrumb. */}
					<div style={{ display: "flex" }}>
						{location.pathname === "/" ? null : <Link to="/"><i className="pi pi-home" /></Link>}
						{resultArray.map((value, index) => {
							const last = index === resultArray.length - 1;
							const to = `/${pathnames.slice(0, index + 1).join("/")}`;
							const noPath = () => {
								if (to === "/subscription" || to === "/reports" || to === "/money" || to === "/crm") {
									return true;
								} else {
									return false
								}
							}

							const isCustomerSection = pathnames[0] === "crm" && pathnames[1] === "customers";
							const isAudienceSection = pathnames[0] === "crm" && pathnames[1] === "audiences";
							const isSegmentsSection = pathnames[0] === "crm" && pathnames[1] === "segments";
							const isEnrichmentSection = pathnames[0] === "crm" && pathnames[1] === "enrichment-requests";
							const checkForPlanRecord = ["plan"]
							const containsPlanValue = checkForPlanRecord.some(value => pathnames.includes(value))

							const handleProductNav = (value) => {
								value = value.trim().toLowerCase()
								if (value === resultArray[0].toLowerCase()) {
									navigate(`/products`)
								} else {
									navigate(`/products/detail/${productId}`)
								}
							};
							const handleCustomerNav = (crumbIndex) => {
								if (crumbIndex === 1) {
									navigate(`/crm/customers`)
								} else if (crumbIndex === 2 && subscriberObject?.id) {
									navigate(`/crm/customers/customer/${subscriberObject.id}`)
								}
							};
							const handleAudienceNav = () => {
								navigate("/crm/audiences");
							};
							const handleSegmentsNav = () => {
								navigate("/crm/segments");
							};
							const handleEnrichmentNav = () => {
								navigate("/crm/enrichment-requests");
							};
							const crumbLabel = isEnrichmentDetail && last && pathnames[2]
								? pathnames[2]
								: value.trim();
							return <div key={index}>
								{(() => {
									if (last || noPath()) {
										return (
											<span key={to}>&nbsp;&gt; {crumbLabel}</span>
										);
									} else if (isEnrichmentSection && index === 1 && !last) {
										return (
											<span>
												&nbsp;&gt;	<span style={{ cursor: "pointer", color: "#E91E63" }} onClick={handleEnrichmentNav}>
													{value.trim()}
												</span>
											</span>
										);
									} else if (isCustomerSection && (index === 1 || index === 2) && !last) {
										return (
											<span>
												&nbsp;&gt;	<span style={{ cursor: "pointer", color: "#E91E63" }} onClick={() => handleCustomerNav(index)}>
													{t(value)}
												</span>
											</span>
										);
									} else if (isAudienceSection && index === 1 && !last) {
										return (
											<span>
												&nbsp;&gt;	<span style={{ cursor: "pointer", color: "#E91E63" }} onClick={handleAudienceNav}>
													{t(value)}
												</span>
											</span>
										);
									} else if (isSegmentsSection && index === 1 && !last) {
										return (
											<span>
												&nbsp;&gt;	<span style={{ cursor: "pointer", color: "#E91E63" }} onClick={handleSegmentsNav}>
													{t(value)}
												</span>
											</span>
										);
									} else if (planId && containsPlanValue) {

										return (
											<span>
												&nbsp;&gt; 	<span style={{ cursor: "pointer", color: "#E91E63" }} onClick={() => handleProductNav(value)}>
													{t(value)}
												</span>
											</span>
										);
									}
									else {
										return (
											<span>
												<span>
													&nbsp;&gt; <Link to={to}>{t(value)}</Link>
												</span>
											</span>
										);
									}
								})()}
							</div>
						}
						)}
					</div>
				</div>
			</div>
			<hr style={{ color: "#D9D9D9", margin: "0px 25px 0px 25px" }} />
			<div>{ActionButtons(visible, defMembership, toogleInviteSubscriber, onHide, onHidePlan, tooglePlan, visiblePlan, business, paymentCredentials, toogleShareBusiness)}</div>
		</>
	);
};
export default Breadcrumbs;